import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AppSessionService } from '../session/app-session.service';

@Injectable()
export class NoAuthGuard implements CanActivate {

  constructor(
    private appSession: AppSessionService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.appSession.user) {
      // Đã đăng nhập → đá về home
      this.router.navigate(['/ecommerce/home']);
      return false;
    }
    return true; // Chưa login → cho vào auth
  }
}